import type { BreadcrumbList, WithContext } from "schema-dts";

import type { BreadcrumbsList } from "../Breadcrumbs";

export type BreadcrumbsJsonLDProps = {
  breadcrumbsList?: BreadcrumbsList;
};

export const buildBreadcrumbsJsonLd = ({
  breadcrumbsList,
}: BreadcrumbsJsonLDProps): WithContext<BreadcrumbList> | null => {
  if (!breadcrumbsList || breadcrumbsList.length === 0) {
    return null;
  }

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: breadcrumbsList.map((breadcrumb, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: breadcrumb.title,
      item: breadcrumb.fullUrl || breadcrumb.url,
    })),
  };
};

export const BreadcrumbsJsonLD = (props: BreadcrumbsJsonLDProps) => {
  const jsonLd = buildBreadcrumbsJsonLd(props);

  if (!jsonLd) {
    return null;
  }

  return <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>;
};
